<nrk-window #window>

    <nrk-header>
        <b>Packing wizard</b>
    </nrk-header>

    <nrk-content>
        <ng-container *ngTemplateOutlet="pageTemplate"></ng-container>
    </nrk-content>

    <nrk-footer>
        <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        <div class="footer">
            <div><button *ngIf="!pallet && page > 0" class="nrk-button" (click)="back()">back</button></div>
            <div><button class="nrk-button" (click)="close()">close</button></div>
            <div>
                <button *ngIf="!pallet && page < pages-1" class="nrk-button" (click)="next()">next</button>
                <button *ngIf="pallet || page === pages-1" class="nrk-button" (click)="save()">save</button>
            </div>
        </div>
    </nrk-footer>

</nrk-window>


<ng-template #pageTemplate><div class="container">

    <div class="page" *ngIf="page === 0">
        <table class="box-info-table">
            <tr><td>Type of Box:</td><td *ngFor="let cb of lineItem?.finishedProduct?.cartonSize"><b>{{cb}}</b></td></tr>
            <tr><td># of Pieces per Box:</td><td *ngFor="let rolls of lineItem?.finishedProduct?.piecesPerCarton"><b>{{rolls}}</b></td></tr>
            <tr><td>&nbsp;</td></tr>
            <tr><td colspan="100" style="background-color:#ffdd66">Color for predefined FPD in finished product</td></tr>
        </table>
        <hr>
        <p>Select final Packing definition:</p>
        <table class="nrk-table fpd-table">
            <tr>
              <th></th><th>ID</th><th>Name</th><!--<th>Pallet</th>--><th>Carton box</th>
              <!--<th>Boxes per layer</th><th>Layers per pallet</th>--><th>Multiplier (%)</th>
              <!--<th>Temperature sticker (T)</th><th>Edge protection (EP)</th>--><th>Text</th>
              <!-- <th></th> -->
            </tr>
            <tbody *ngFor="let boxType of validBoxTypes">
                <tr style="background-color:transparent;cursor:default"><td colspan="100">For Box type: {{boxType}}</td></tr>
                <ng-container *ngFor="let row of finalPackingOptions[boxType]">
                    <tr (click)="result.finalPacking[boxType]=row" [ngStyle]="{ 'background-color': row.fp ? '#ffdd66' : null }">
                        <td><input type="radio" [name]="boxType" [value]="row" [(ngModel)]="result.finalPacking[boxType]"/></td>
                        <td>{{row.id}}</td>
                        <td>{{row.name}}</td>
                        <!-- <td>{{row.pallet}}</td> -->
                        <td>{{row.cartonBox}}</td>
                        <!-- <td>{{row.boxesPerLayer}}</td> -->
                        <!-- <td>{{row.layersPerPallet}}</td> -->
                        <td>{{row.multiplier}}</td>
                        <!-- <td>{{row.temperatureSticker}}</td> -->
                        <!-- <td>{{row.edgeProtection}}</td> -->
                        <td>{{row.text}}</td>
                        <!-- <td><button class="nrk-button" (click)="result.finalPacking=row; next();">select</button></td> -->
                    </tr>
                </ng-container>
            </tbody>
        </table>
        <div *ngIf="!validBoxTypes?.length" class="mt-4 text-center">
            Error: <br>
            <span *ngIf="spoBoxes?.length">No matching boxes found. Please use the utilities to define the packing specs.</span>
            <span *ngIf="!spoBoxes?.length">No matching boxes found. Please add them via associated (PF)SPOs in the line items.</span>
        </div>
    </div>


    <div class="page" *ngIf="page === 1">

        <ng-container *ngIf="pallet">
            <p><b>{{tree.linkedDN?.code || tree.linkedOC?.code}}</b> Pos: <b>{{(pallet.lineItemIdx || 0) + 1}}</b> - Pallet: <b>{{pallet?.palId || ''}}</b> ({{palletIdx + 1}}/{{numPallets}}) - Net Weight: <b>{{(pallet?.netWeight || 0) | ngxRound}}</b> kg</p>

            <p>Max load per pallet: <b>{{ getPacking(pallet)?.boxesPerLayer }}</b> boxes per layer, <b>{{ getPacking(pallet)?.layersPerPallet }}</b> layers per pallet
                = max <b>{{getPacking(pallet)?.boxesPerLayer * getPacking(pallet)?.layersPerPallet}}</b> boxes
            </p>
        </ng-container>

        <p>Select Boxes:</p>

        <table class="nrk-table mt-2">
            <tr *ngIf="!warehousing"><th></th><th>PFSPO #</th><th>Pos</th><th>Pallet Id</th><th>Case</th><th>Box Id</th><th>Lot</th><th>TC</th><th>Quantity</th></tr>
            <tr *ngIf="warehousing"><th></th><th>TC</th><th>Case</th><th>Box Id</th><th>Quantity</th><th>Lot</th><th>Pallet Id</th><th>PFSPO #</th><th>Pos</th></tr>
            <ng-container *ngFor="let lot of getProductionLotTable(); index as row">
                <tr *ngIf="!warehousing" [ngStyle]="{ 'background-color': ['#9f9', '#8ef','#acf', '#ddd', '#fd8', '#f77'][lot.status], 'opacity': [1, 1, 1, 0.5][lot.status] }">
                    <td class="text-center">
                    <!-- <input type="checkbox" [(ngModel)]="lot.selected" (mouseup)="onCheckboxChange(row, $event)"></td> -->
                    <ngx-doc-form-checkbox *ngIf="canEditBoxStatus(lot)" [withEvent]="true" [value]="lot.selected || lot.status === 2" (valueWithEventChange)="onCheckboxChange(row, $event)"></ngx-doc-form-checkbox>
                    <td>{{lot.spo}}</td>
                    <td class="text-center">{{lot.pos}}</td>
                    <td class="text-center">{{lot.palletId}}</td>
                    <td class="text-center">{{lot.case}}</td>
                    <td class="text-center">{{lot.boxId}}</td>
                    <td>{{lot.lot}}</td>
                    <td>{{lot.tc}}</td>
                    <td class="text-right">{{lot.quantity}}</td>
                </tr>
                <tr *ngIf="warehousing" [ngStyle]="{ 'background-color': ['#9f9', '#8ef','#acf', '#ddd', '#fd8', '#f77'][lot.status], 'opacity': [1, 1, 1, 0.5][lot.status] }">
                    <td class="text-center">
                    <ngx-doc-form-checkbox *ngIf="canEditBoxStatus(lot)" [withEvent]="true" [value]="lot.selected || lot.status === 2" (valueWithEventChange)="onCheckboxChange(row, $event)"></ngx-doc-form-checkbox>
                    <td>{{lot.tc}}</td>
                    <td class="text-center">{{lot.case}}</td>
                    <td class="text-center">{{lot.boxId}}</td>
                    <td class="text-right">{{lot.quantity}}</td>
                    <td>{{lot.lot}}</td>
                    <td class="text-center">{{lot.palletId}}</td>
                    <td>{{lot.spo}}</td>
                    <td class="text-center">{{lot.pos}}</td>
                </tr>
            </ng-container>
          </table>
    </div>


    <div class="page" *ngIf="page === 2">
        <p>select box sort order</p>
        <nb-radio-group name="sortOrder" [(ngModel)]="result.sortOrder">
            <nb-radio [value]="1">Ascending</nb-radio>
            <nb-radio [value]="-1" checked>Descending</nb-radio>
        </nb-radio-group>
    </div>


</div></ng-template>



<ng-template #footerTemplate>
    <div *ngIf="page === 1">
        <div class="text-center mt-2"><b class="mr-2">Σ Boxes</b>{{getSumBoxesQuantity(productionLotTable)?.boxes}}<b class="ml-3 mr-2">Σ Q</b>{{getSumBoxesQuantity(productionLotTable).quantity}}</div>
        <div class="text-center mt-2 mb-2">
            <button class="nrk-button" (click)="selectAll(true)">Select all</button>
            <button class="nrk-button ml-4" (click)="selectAll(false)">Select none</button>
            <button class="nrk-button ml-4" (click)="markAs(BoxStatusType.damaged)">Mark as Damaged</button>
            <button class="nrk-button ml-1" (click)="markAs(BoxStatusType.lost)">Mark as Lost</button>
        </div>
    </div>
</ng-template>
